(function() {
  const inputs = document.querySelectorAll('.custom-input-file');
  Array.prototype.forEach.call(inputs, function(input) {
    const label = input.nextElementSibling;
    const labelVal = label.innerHTML;

    input.addEventListener('change', function(e) {
      let fileName = '';
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      else fileName = e.target.value.split('\\').pop();

      if (fileName) label.innerHTML = fileName;
      else label.innerHTML = labelVal;
    });

    // Firefox bug fix
    input.addEventListener('focus', function() {
      input.classList.add('has-focus');
    });
    input.addEventListener('blur', function() {
      input.classList.remove('has-focus');
    });
  });
})();



// WEBPACK FOOTER //
// ./scripts/components/CustomInputFile.js